module.exports = __webpack_public_path__ + "static/ss2.34407c5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/tst/ss2.png
// module id = 1209
// module chunks = 39732927749384